<template>
    <div>
        <detalhespedido v-bind:idpedido="vidpedidodet" v-bind:rotinacorte="crotinacortes"></detalhespedido>        
        <div class="modal fade" id="mdpedidosreservados" tabindex="-1" role="dialog" aria-labelledby="mdpedidosreservados" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="fa fa-codepen"></i> Pedidos reservados</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="padding-bottom: 0px;">
                        <div class="row" v-show="mostrar">
                            <div class="col-md-12 text-center">
                                <div class="alert alert-primary" role="alert">
                                    <span style="color: #666666; font-weight: 600;">{{idproduto}} - {{descricao}}</span>
                                </div>                                                                
                            </div>
                            <div v-if="lstpedidos.length > 0" class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table table-bordered table-sm table-hover">
                                        <thead class="thead-light">
                                            <tr style="font-weight: 100;">
                                                <th>Nr. Pedido:</th>
                                                <th></th>
                                                <th>Cliente:</th>
                                                <th>Vendedor:</th> 
                                                <th>Qtd:</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(pedido, index) in lstpedidos" v-bind:key="index">
                                                <td style="font-weight: 600;">{{ pedido.idpedido }}</td>
                                                <td style="width: 30px; text-align: center;"><i @click.prevent="mtddetalhespedido(pedido.idpedido)" class="fa fa-info-circle icon-detalhes" title="Detalhes do pedido"></i></td>
                                                <td style="font-weight: 300;">{{  mtdformatarzeros(pedido.idcliente, 6) }} - {{ pedido.nomecliente }}</td>
                                                <td style="font-weight: 300;">{{ pedido.nomevendedor }}</td>
                                                <td style="text-align: right; font-weight: 600;">
                                                    {{mtdformatavalordecimal(parseFloat(pedido.qtditem), 3)}}
                                                </td>                                                        
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-else class="col-md-12" style="padding-bottom: 10px;">
                                <ul class="list-group">
                                    <li class="list-group-item text-center">
                                        <span>
                                            NÃO HÁ PEDIDOS RESERVADOR COM O PRODUTO INFORMADO
                                        </span>
                                    </li>
                                </ul>                                
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal"><i class="fa fa-sign-out"></i> Fechar</a>
                    </div>
                </div>
            </div>
        </div>                
    </div>
</template>
<script>
import util from '../utilitarios/util.js'
import DetalhesPedido from '../components/cmpdetalhespedido.vue'	
export default {
    components:{
	    'detalhespedido'  		: DetalhesPedido
    },    
    name: 'cmppedidosreservados',
    props:[
                'idproduto',
                'descricao'
          ],
    data: function() {
        return {
            //variável para detalhes do pedido
            vidpedidodet : '',            
            //////////////////////////////////
            mostrar             : false,//variável só pra esconder a visualização da div
            lstpedidos         : [],
            money				: {
                decimal         : ',',
                thousands       : '.',
                prefix          : '',//aqui colocar o cifrão se for necessário
                precision       : 2,
                masked          : false
            }            
        };
    },
    methods: {
        mtdformatavalordecimal(valor, digitos){
            return util.formatavalordecimais(valor, digitos);
        },
        mtdformatarzeros(str, length){
            return util.formatarzeros(str, length);
        },        
        mtdlistarpedidosreservados(){
            let vself       = this;
            let loader      = vself.$loading.show();
            let filtro      = ' and i.idproduto='+vself.idproduto;
            let parametros  			= [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           	valor : 'produtosreservados'},
                {parametro: 'filtro', 	        valor : filtro}
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
            retorno.then(function (response) {
                vself.lstpedidos  = response.data.produtos;                  
                loader.hide();             
                vself.mostrar     = true;  
            }).catch(function (response) {
                vself.mostrar     = false;  
                loader.hide();
            });
        },
        mtddetalhespedido(idpedido){
            this.vidpedidodet = 0;
            this.vidpedidodet = idpedido;
            $('#mddetalhespedido').modal('show');
        }
    },
    mounted: function() {
        let vself = this;
        $("#mdpedidosreservados").on('shown.bs.modal', function(){
            vself.mtdlistarpedidosreservados();
        });
        $("#mdpedidosreservados").on('hide.bs.modal', function(){
            vself.mostrar     = false;
            vself.lstpedidos  = [];
        });                        
    },    
    computed:{ 
    },
    watch: {
    }
}
</script>
<style>
    #mdpedidosreservados{
        z-index: 2002!important;
    }  
</style>